import { postRequest } from './requestUtils';
import { analyticsTrack } from './analyticsUtils';

export const sendConfirmationEmail = (event, url, email, csrfToken, location, replacementText) => {
  const { target } = event;
  postRequest(url, { email }, csrfToken)
    .then(() => {
      analyticsTrack('Resend confirmation email', { location });
      target.replaceWith(replacementText || 'Sent!');
    });
};

export default sendConfirmationEmail; // Default export
